import { useEffect, useState } from 'react'
import axios from 'axios'
import { LifecycleStage } from './lifecycle'

export interface CustomerProfile {
  customerId: string
  name: string
  industry: string
  location: string
  otherLocations: string[]
  bio: string
  notes: string
  companyValues: string[]
  numberOfEmployees: string
  currencyCode: string
  yearFounded: string
  website?: string
  deviceValue?: string | number
  pageCostBW?: string | number
  pageCostColor?: string | number
  lifecycleStage?: LifecycleStage | ''
}

export interface CustomerProfileState {
  profile?: CustomerProfile
  loading: boolean
}

export const useCustomerProfile = (teamID: string, customerID: string): CustomerProfileState => {
  const [state, setState] = useState<CustomerProfileState>({ loading: true })

  useEffect(() => {
    const controller = new AbortController()

    setState({ loading: true })
    axios
      .get<CustomerProfile>(`/api/teams/${teamID}/customers/${customerID}/profile`, { signal: controller.signal })
      .then(response => {
        if (!controller.signal.aborted) setState({ profile: response.data, loading: false })
      })
      .catch(() => {
        if (!controller.signal.aborted) setState({ loading: false })
      })

    return () => controller.abort()
  }, [teamID, customerID])

  return state
}
